import React, { useEffect } from 'react'
import AppLayout from 'components/layout/layout'
import './styles/manage-web-content.scss'
import WebEditor from './components/WebEditor'
import WebContent from './components/WebContent'
import { useGetWebContent } from 'api/Settings/WebContent'
import Spinner from 'components/Spinner'
import { webContentStore } from 'state/setting/webContent'

const ManageWebContent: React.FC = () => {
  const {
    setSlides,
    setHeading,
    setHeadingBefore,
    setHeadingColored,
    setHeadingAfter,
    setDescription,
    setButtonText,
    setButtonLink,
  } = webContentStore(store => ({
    setSlides: store.setSlides,
    setHeading: store.setHeading,
    setHeadingBefore: store.setHeadingBefore,
    setHeadingColored: store.setHeadingColored,
    setHeadingAfter: store.setHeadingAfter,
    setDescription: store.setDescription,
    setButtonText: store.setButtonText,
    setButtonLink: store.setButtonLink,
  }))
  const { data, isLoading, isFetching, refetch } = useGetWebContent()

  useEffect(() => {
    refetch()
  }, [])

  useEffect(() => {
    if (data && Array.isArray(data)) {
      // Map API data into slides for carousel consumption
      const mappedSlides = data.map((item, idx) => {
        const galleryPlaceholders = Array.from({ length: 9 }, () => '')
        if (Array.isArray(item.galleries)) {
          item.galleries.forEach(g => {
            if (!g) return
            const index = (g.imageIndex || 0) - 1
            if (index >= 0 && index < 9) {
              const src = g.image?.thumb || g.image?.original || ''
              galleryPlaceholders[index] = src || ''
            }
          })
        }
        return {
          id: item.id || item._id || idx + 1,
          content: {
            heading: item.content?.heading || '',
            headingBefore: item.content?.headingBefore || '',
            headingColored: item.content?.headingColored || '',
            headingAfter: item.content?.headingAfter || '',
            description: item.content?.description || '',
            buttonText: item.content?.buttonText || '',
            buttonLink: item.content?.buttonLink || '#',
          },
          type: item.type || 'none',
          videoLink: item.videoLink || undefined,
          imageLink: item.imageLink || undefined,
          commonEventId: item.commonEventId || undefined,
          gallery: galleryPlaceholders,
        }
      })
      setSlides(mappedSlides)

      // Preserve previous single-slide editor previews (optional defaults from first)
      if (mappedSlides[0]) {
        setHeading(mappedSlides[0].content.heading || '')
        setHeadingBefore(
          mappedSlides[0].content.headingBefore || 'Before title',
        )
        setHeadingColored(
          mappedSlides[0].content.headingColored || 'Colored title',
        )
        setHeadingAfter(mappedSlides[0].content.headingAfter || 'After title')
        setDescription(
          mappedSlides[0].content.description || 'Few words about the external',
        )
        setButtonText(mappedSlides[0].content.buttonText || 'Learn more')
        setButtonLink(mappedSlides[0].content.buttonLink || '#')
      }
    }
  }, [data])

  return (
    <AppLayout>
      <div className="main-container">
        {isLoading || isFetching ? (
          <div className="flex justify-center py-40px">
            <Spinner />
          </div>
        ) : (
          <>
            <div className="main-content-container">
              <div className="web-view-container">
                <WebContent />
              </div>
              <div className="web-eidtor-container">
                <WebEditor />
              </div>
            </div>
          </>
        )}
      </div>
    </AppLayout>
  )
}

export default ManageWebContent
